import React, { useEffect, useRef, useState } from "react";
import MenuIcon from "../../../images/horizontal-icon.svg";
import DBSIcon from "../../../images/dbs.svg";
import FeaturedIcon from "../../../images/featured.svg";
import EditIcon from "../../../images/edit.svg";
import LoginIcon from "../../../images/login.svg";
import DeleteIcon from "../../../images/delete.svg";
import InactiveIcon from "../../../images/inactive.svg";
import TimeIcon from "../../../images/time.svg";
import LTVIcon from "../../../images/ltv.svg";
import { useSelector } from "react-redux";
import { getNameFromSettings, getTime } from "../../../helpers/utils";
import {
  LOAN_PROVIDER_IMAGE_BASE_URL,
  SETTINGS_APPROVAL_TIME_LIST,
  SETTINGS_LOAN_PROVIDERS_LIST,
  SETTINGS_LTV_LIST,
  SETTINGS_PRODUCT_TYPE_LIST,
} from "../../../helpers/constants";
import MoreIcon from "../../../images/more-horizontal.png";
import { FaCrown } from "react-icons/fa";
import { AiFillStar } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import {
  Menu,
  MenuItem,
  ThemeProvider,
  alpha,
  createTheme,
  styled,
  TextField,
  Dialog, DialogTitle, DialogContent, DialogActions, Button
} from "@mui/material";
import { useCallback } from "react";
import { SecurityPinNumber } from "./SecurityPinNumber";
import Noimage from "../../../images/noimage.png";

export default function AgentGridItem(props) {
  const {
    data,
    onFeatureClick,
    onDeleteClick,
    handleCloseMenu,
    handleOpenMenu,
    menuOpen,
    anchorEl,
    handleLogin,
    index,
    pagePermission,
  } = props;
  const settings = useSelector((state) => state.settings);
  const navigate = useNavigate();

  const onDelete = useCallback(() => {
    onDeleteClick(data.id);
    handleCloseMenu();
  }, [data, onDeleteClick, handleCloseMenu]);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [pin, setPin] = useState("");
  const [updateData, setUpdateData] = useState({ name: data.name });
  return (
    <ThemeProvider theme={createTheme()}>
      <div
        id={data.id}
        className="rounded-[16px] bg-white  p-[16px_20px] w-[32%] max-[1300px]:w-[48%] max-[1200px]:w-[48%] max-[700px]:w-[100%] max-w-[100%] cus_shadow2 relative z-0"
      >
        <div className="card_head relative flex justify-between items-center mb-[10px]">
          <div className="absolute top-[-33px] left-0 bg-white h-[58px] w-[58px] rounded-[8px]">
            {/* <img
              src={`${LOAN_PROVIDER_IMAGE_BASE_URL}/${data.icon}`}
              alt="Bank Logo"
              className="rounded-[8px]"
              width="58"
              height="58"
              style={{ maxWidth: "100%", height: "auto" }}
            /> */}
            <img
              src={
                data?.icon
                  ? `${LOAN_PROVIDER_IMAGE_BASE_URL}/${data.icon}`
                  : Noimage // ✅ Use fallback image if no avatar
              }
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Noimage; // ✅ Set fallback image on error
              }}
              alt="Bank Logo"
              className="rounded-[8px]"
              width="58"
              height="58"
              style={{ width: "auto", height: "40px", margin: "10px auto" }}
            />
          </div>
          <span className="pl-[70px] flex-fixed font-[700] line-clamp-1">
            {data.name}
          </span>
          {pagePermission?.update_permission == 1 && (
            <div className="py-1 px-2 gap-2">
              <img
                src={MoreIcon}
                className="w-5 cursor-pointer"
                onClick={(e) => handleOpenMenu(index, e)}
                id="fade-button"
              />
              <div className="menu-container ">
                <Menu
                  id="fade-button"
                  MenuListProps={{
                    "aria-labelledby": "demo-customized-button",
                  }}
                  anchorEl={anchorEl}
                  open={menuOpen}
                  onClose={handleCloseMenu}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.1))",
                      mt: 1,
                      minWidth: "140px",
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <MenuItem
                    onClick={() => navigate(`/accounts/agents/${data.id}`)}
                    // onClick={() => onEditClick(data)}
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: '"Inter", sans-serif',
                    }}
                  >
                    <img src={EditIcon} className="h-4 w-4 mr-4" />
                    View Agent
                  </MenuItem>
                  {pagePermission.delete_permission == 1 && (
                    <MenuItem
                      onClick={onDelete}
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                        fontFamily: '"Inter", sans-serif',
                      }}
                    >
                      <img src={DeleteIcon} className="h-4 w-4 mr-4" />
                      Delete
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={() => handleLogin(data.id)}
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: '"Inter", sans-serif',
                    }}
                  >
                    <img src={LoginIcon} className="h-4 w-4 mr-4" />
                    Login
                  </MenuItem>
                </Menu>
              </div>
            </div>
          )}
        </div>
        <div className="flex items-center gap-x-2">
          {data?.hasPremium ? (
            <div className="items-center inline-block mb-[8px] p-[1px] px-2 flex text-[12px] font-[500] border border-1 rounded-[4px] z-[-1] ">
              <FaCrown size={23} color="#ffac04" className="pe-2" />
              <p>{`Premium`}</p>
            </div>
          ) : null}
          <div
            onClick={() => onFeatureClick(data.id, data.featured)}
            className={`items-center inline-block mb-[8px] p-[1px] px-2 flex text-[12px] font-[500] border border-1 rounded-[4px] cursor-pointer`}
          >
            <AiFillStar
              size={24}
              color={`${data.featured ? "#ffac04" : "#d3d3d3"}`}
              className={`pe-2`}
            />
            <p>{`Featured`}</p>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-[12px_15px] mt-[5px] mb-[9px]">
          <div className="w-[46%] max-[600px]:w-full">
            <p className="text-[11px] text-gray-500">UEN Number:</p>
            <p className="text-[13px] md:text-xs text-black font-[600] tracking-[-.15px]">
              {data.uenNumber}
            </p>
          </div>
          <div className="w-[46%]  max-[600px]:w-full">
            <p className="text-[11px] text-gray-500">
              {data.status == 0
                ? "Registered"
                : data.status == 1
                  ? "Approved"
                  : data.status == 2
                    ? "Rejected"
                    : data.status == 3
                      ? "Banned"
                      : ""}{" "}
              Date:
            </p>
            <p className="text-[13px] md:text-xs text-black font-[600] capitalize tracking-[-.15px]">
              {data.status == 0
                ? getTime(data.created_at)
                : data.status == 1
                  ? getTime(data.approvedAt)
                  : data.status == 2
                    ? getTime(data.rejectedAt)
                    : data.status == 3
                      ? getTime(data.bannedAt)
                      : ""}
            </p>
          </div>
          <div className="w-[46%] max-[600px]:w-full">
            <p className="text-[11px] text-gray-500">Contact Number:</p>
            <p className="text-[13px] md:text-xs text-black font-[600] capitalize tracking-[-.15px]">
              {data.phoneNumber}
            </p>
          </div>
          <div className="w-[46%] max-[600px]:w-full">
            <p className="text-[11px] text-gray-500">Email:</p>
            <p className="text-[13px] md:text-xs text-black font-[600] tracking-[-.15px]">
              {data.email}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap justify-between items-center gap-[10px] mt-[15px]">
          <div className="flex gap-[7px] w-[46%] max-[600px]:w-full">
            <div className="flex items-center col-span-4">
              <img src={TimeIcon} className="w-3 h-3 mr-1" />
              <p className="text-[13px] md:text-xs truncate text-gray-500">
                Approval Time:
              </p>
            </div>
            <div className="col-span-4">
              <p className="text-[13px] md:text-xs text-black font-[600] capitalize truncate tracking-[-.15px]">
                {getNameFromSettings(
                  settings,
                  SETTINGS_APPROVAL_TIME_LIST,
                  data.approvalTime
                )}
              </p>
            </div>
          </div>
          <div className="flex gap-[7px] w-[46%] max-[600px]:w-full">
            <div className="flex items-center col-span-4">
              <img src={LTVIcon} className="w-3 h-3 mr-1" />
              <p className="text-[13px] truncate md:text-xs text-gray-500">
                Loan to Value:
              </p>
            </div>
            <div className="col-span-4">
              <p className="text-[13px] truncate md:text-xs text-black font-[600] capitalize tracking-[-.15px]">
                {getNameFromSettings(settings, SETTINGS_LTV_LIST, data.ltv)}
              </p>
            </div>
          </div>
        </div>
      </div>

      <SecurityPinNumber
        open={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        onConfirm={(pin) => {
          // Validate pin or perform login
          navigate(`/login-as-agent/${data.id}`);
          setIsLoginModalOpen(false);
        }}
      />

    </ThemeProvider>
  );
}
